import Modal from "react-modal";
import * as S from "./styles";
import Close from "assets/close-small.svg";
import { IUpdatePolicemen } from "interfaces/Policeman";
import { Button } from "components/Button";
import { confirmUpdatePolicemen } from "services/PolicemenServices";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  modifiedPoliceman: IUpdatePolicemen;
}

export function MoreModifiedPolicemanDetailsModal({
  modalIsOpen,
  setIsOpen,
  modifiedPoliceman,
}: ModalProps) {
  const policemanApproved = modifiedPoliceman.policeman.approved;

  function closeModal() {
    setIsOpen(false);
  }

  const types = [
    "Usuário PRMA",
    "Fornecedor",
    "Policia",
    "Cliente",
    "Funcionário de Cliente",
    "Funcionário de Fornecedor",
  ];

  console.log({ modifiedPoliceman })

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="MorePolicemanDetails Modal"
      contentElement={(props, children) => (
        <S.MorePolicemanModalContent
          {...props}
          isApprovalModal={!policemanApproved}
        >
          {children}
        </S.MorePolicemanModalContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.MorePolicemanModalOverlay {...props}>
          {contentElement}
        </S.MorePolicemanModalOverlay>
      )}
    >
      <S.Container>
        <S.MorePolicemanHeader>
          <header>
            <h2>{policemanApproved ? "Dados do agente" : "Aprovar agente"}</h2>
            <img src={Close} alt="fechar" onClick={closeModal} />
          </header>
        </S.MorePolicemanHeader>
        <S.MorePolicemanDetailsContent>
          <S.MorePolicemanContainer>
            <S.BadgeContainer>
              <span>
                <label>Efetuou o cadastro em</label>
                <p>
                  {new Date(modifiedPoliceman.createdAt).toLocaleDateString(
                    "pt-BR",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </p>
              </span>
            </S.BadgeContainer>

            <S.DataContainer>
              <h3>Dados</h3>
              <S.MorePolicemanContent>
                <span>
                  <label>Nome do pronta-resposta</label>
                  <p>{modifiedPoliceman?.user?.name}</p>
                </span>
                <span>
                  <label>Contato</label>
                  <p>{modifiedPoliceman?.contact?.phoneNumber}</p>
                </span>
                <span>
                  <label>RG</label>
                  <p>{modifiedPoliceman?.user?.rg}</p>
                </span>
                <span>
                  <label>Tipo de usuário</label>
                  {modifiedPoliceman?.user?.type && (
                    <p>{types[modifiedPoliceman?.user?.type - 1]}</p>
                  )}
                </span>
                <span>
                  <label>CPF</label>
                  <p>{modifiedPoliceman?.user?.cpf}</p>
                </span>
                <span>
                  <label>E-mail</label>
                  <p>{modifiedPoliceman?.user?.email}</p>
                </span>
                <span>
                  <label>Veículo</label>
                  <p>{modifiedPoliceman?.vehicle?.model}</p>
                </span>
                <span>
                  <label>Marca</label>
                  <p>{modifiedPoliceman?.vehicle?.brand}</p>
                </span>
                <span>
                  <label>Placa</label>
                  <p>{modifiedPoliceman?.vehicle?.plate}</p>
                </span>
                <span>
                  <label>Endereço</label>
                  <p>{`${modifiedPoliceman?.address.street}, ${modifiedPoliceman.address.number} - ${modifiedPoliceman.address.district}, ${modifiedPoliceman.address.city} - ${modifiedPoliceman.address.uf}, ${modifiedPoliceman.address.postalCode}`}</p>
                </span>
              </S.MorePolicemanContent>
            </S.DataContainer>

            <S.DataContainer>
              <h3>Sobre o agente</h3>
              <S.MorePolicemanContent>
                <span>
                  <label>Região preferida</label>
                  <p>{modifiedPoliceman?.policeman?.region}</p>
                </span>
                <span>
                  <label>É agente público?</label>
                  <p>
                    {modifiedPoliceman?.policeman.publicAgent ? "Sim" : "Não"}
                  </p>
                </span>
                <span>
                  <label>Está na ativa?</label>
                  <p>{modifiedPoliceman?.policeman.working ? "Sim" : "Não"}</p>
                </span>
              </S.MorePolicemanContent>
            </S.DataContainer>

            <S.DataContainer>
              <h3>Conta bancária</h3>
              <S.MorePolicemanContent>
                <span>
                  <label>Chave PIX</label>
                  <p>{modifiedPoliceman?.banking?.accountData?.pix || "--"}</p>
                </span>
                <span>
                  <label>Conta</label>
                  <p>{modifiedPoliceman?.banking?.accountData?.account || '--'}</p>
                </span>
                <span>
                  <label>Agência</label>
                  <p>{modifiedPoliceman?.banking?.accountData?.agency || '--'}</p>
                </span>
                <span>
                  <label>Banco</label>
                  <p>{modifiedPoliceman?.banking.accountData.bank || "--"}</p>
                </span>
              </S.MorePolicemanContent>
            </S.DataContainer>
          </S.MorePolicemanContainer>

          <S.Footer>
            <Button onClick={() => confirmUpdatePolicemen(modifiedPoliceman.id, true)}>
              Aprovar
            </Button>

            <Button variant="error" onClick={() => confirmUpdatePolicemen(modifiedPoliceman.id, false)}>
              Negar
            </Button>
          </S.Footer>
        </S.MorePolicemanDetailsContent>
      </S.Container>
    </Modal>
  );
}
